<div class="gap-4">
    @for (item of items; track $index) {
    <div class="w-full bg-white rounded-lg overflow-hidden border-b border-gray-300 py-4
           grid grid-cols-2 gap-4 md:flex md:flex-row md:items-stretch">

        <div class="flex flex-col md:flex-row md:flex-1  md:items-stretch">

            <div class="hidden md:block w-24 h-24">
                <img [src]="absoluteMediaUriService.getAbsoluteMediaUri(item.imageUrl) || 'item-default.jpg'"
                    alt="item.itemName + 'image'" class="w-full h-full object-cover rounded-lg">
            </div>


            <div class="flex flex-col md:pl-4 w-full md:flex-1">
                <a [routerLink]="['/auctions', item.auctionId, 'items', item.itemId]">
                    <h3 class="text-[var(--dark-blue)] text-xl  font-semibold hover:underline cursor-pointer"
                        [innerHTML]="item.itemName  | sanitizeHtmlText">
                    </h3>
                </a>
                <a class="text-[var(--black)]  hover:underline cursor-pointer"
                    [routerLink]="['/auction', item.auctionId]">
                    <p class="text-[var(--fs-black)]  md:mt-2 md:mb-2">{{ item.orgName }}</p>
                </a>
                <p class=" hidden md:block text-[var(--fs-black)] font-medium italic text-sm ">{{
                    timeLeftService.getTimeLeft(item.openingDate, item.closingDate) }}</p>
            </div>


            <div class="flex flex-col  w-full md:flex-1  lg:pl-8">
                <ng-container *ngIf="item.isLeader">
                    <div class=" hidden md:block   w-40 mb-2">
                        <span
                            class="flex items-center bg-[var(--fs-forest)] text-white px-3 py-1 rounded-full text-xs font-semibold h-7">
                            <fa-icon [icon]="faCrown" class="mr-1 text-sm"></fa-icon>
                            You're Leading
                        </span>
                    </div>
                </ng-container>
                @if(item.isLeader)
                {

                <p class="text-[var(--fs-black)] text-sm font-bold lg:mt-2 lg:mb-1">
                    <span [ngClass]="item.leadingBid ? 'text-[var(--fs-black)]' : 'text-[var(--fs-forest)]'">
                        {{ item.leadingBid || '-'}}</span>
                    <span class="text-[var(--fs-forest)] text-sm font-medium"> Your Bid</span>
                </p>
                <p class="text-[var(--fs-black)] text-sm font-bold">
                    {{ item.myMaxBid }}
                    <span class="text-[var(--fs-forest)] text-sm font-medium">Your Max Bid</span>
                </p>

                }@else{
                <p class="text-[var(--fs-black)] text-sm font-bold lg:mt-2 lg:mb-2">
                    <span [ngClass]="item.leadingBid ? 'text-[var(--fs-black)]' : 'text-[var(--dark-blue)]'">
                        {{ item.myMaxBid || '-'}}</span>
                    <span class="text-[var(--dark-blue)] text-sm font-medium"> Your Bid</span>
                </p>
                <p class="text-[var(--fs-black)] text-sm font-bold">
                    {{ item.leadingBid }}
                    <span class="text-[var(--dark-blue)] text-sm font-medium">Leading Bid</span>
                </p>
                }
            </div>
        </div>

        <div class="flex flex-col md:gap-4 md:flex-row items-end  md:items-center ">
            <ng-container *ngIf="item.isLeader">
                <div class="block md:hidden lg:mt-2 w-40 order-1 md:order-none">
                    <span
                        class="flex items-center bg-[var(--fs-forest)] text-white px-3 py-1 rounded-full text-xs font-semibold h-7">
                        <fa-icon [icon]="faCrown" class="mr-1 text-sm"></fa-icon>
                        You're Leading
                    </span>
                </div>
            </ng-container>


            <div class="flex items-center space-x-2 order-2 md:order-none ">
                <span class="text-[var(--fs-black)] text-sm font-medium">Email me</span>
                <!-- <p-inputSwitch class="scale-75 " [(ngModel)]="item.isReceivingEmailAlerts"
                    (onChange)="onPutEmailAddress(item.itemId, item.isReceivingEmailAlerts)"></p-inputSwitch>
                    (onChange)="onPutEmailAddress(item.itemId, $event.checked)"></p-inputSwitch> -->

                    <p-toggleSwitch
                            class="scale-75"
                            [(ngModel)]="item.isReceivingEmailAlerts"
                            (onChange)="onPutEmailAddress(item.itemId, item.isReceivingEmailAlerts)">
                    </p-toggleSwitch>
            </div>

            <button class="ml-0 md:ml-4 order-3 md:order-none "
                (click)="onConfirmRemove(item.itemId, item.myMaxBid && item.myMaxBid.trim() !== '' ? true:false )">
                <fa-icon [icon]="faTrashCan" class="mr-1 text-xl font-bold text-[#6E6E6E]"></fa-icon>
            </button>

            <p class="block md:hidden text-[var(--fs-black)] font-medium italic text-sm order-4 md:order-none mt-2">
                {{ timeLeftService.getTimeLeft(item.openingDate, item.closingDate) }}
            </p>
        </div>

    </div>
    }

</div>